import { Box, BoxProps } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

import styles from "./AccordioItem.module.css";
import classNames from "classnames";

interface AccordionItemProps extends BoxProps {
  title: string;
  defaultOpen?: boolean;
}
export const AccordionItem = ({
  title,
  defaultOpen,
  children,
  ...props
}: AccordionItemProps) => {
  const [open, setOpen] = useState<boolean | null>(null);
  const calcOpen = open === null ? !!defaultOpen : open;
  return (
    <Box {...props}>
      <Box
        as="button"
        display="flex"
        width="100%"
        border="0"
        backgroundColor="transparent"
        textAlign="left"
        alignItems="center"
        cursor="pointer"
        gap="1rem"
        onClick={() => setOpen(!calcOpen)}
      >
        <Box
          as="h2"
          fontFamily="work-sans"
          color="brand.green.dark"
          className={styles.h2}
          fontSize="1.2rem"
          flex={1}
          fontWeight={400}
        >
          {title}
        </Box>
        <Box
          color="brand.green.dark"
          fontSize="36px"
          className={classNames(styles.titleChevron, {
            [styles.open]: calcOpen,
          })}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </Box>
      </Box>
      <Box className={classNames(styles.content, { [styles.open]: calcOpen })}>
        {children}
      </Box>
    </Box>
  );
};
